<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
    
        <b-col cols="10">
        <b-form inline>
          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="税号/名称"
            v-model="queryParam.criteria.keywords"
          ></b-form-input>

          <b-button variant="outline-primary" @click="handleQuery" class="m-1">查询</b-button>
        </b-form>
      </b-col>

    </b-row>
    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"

      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(statusMessage)="row">
          <div v-if="row.item.statusMessage!=null">{{ row.item.statusMessage }}</div>
          <div v-else>待处理</div>
        </template>

        <!-- <template v-slot:cell(accStatus)="data">
          <b-badge variant="secondary" v-if="data.value=='0'">未入账</b-badge>
          <b-badge variant="success" v-if="data.value=='1'">已入账</b-badge>
          <b-badge variant="primary" v-if="data.item.status=='0'" class="ml-1">正常</b-badge>
          <b-badge variant="danger" v-if="data.item.status !='0'" class="ml-1">异常</b-badge>
          <b-badge variant="warning" class="ml-1">{{getInvTypeName(data.item.cataCode)}}</b-badge>
        </template> -->

     

        <template v-slot:cell(actions)="row">
        
          <b-link @click="handleView(row.item)" class="mr-2" >查看</b-link>



        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>

   
   
  </div>
</template>

<script>
import * as entFacade from "@/api/ent-facade.js";

import { mapState } from "vuex";
import { zhCN } from "date-fns/locale";
import {
  addDays,
  addHours,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

//import dayjs from "dayjs";

export default {
  // validations:
  data() {
    return {
  
      daterange: {
        local: zhCN,
        locale: {
          localize: "zhCN",
          //汉化
          format: "YYYY-MM-DD", //设置显示格式
          applyLabel: "确定", //确定按钮文本
          cancelLabel: "取消", //取消按钮文本
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          firstDay: 1
        },
        dateFormat: "yyyy-MM-dd",
        ranges: {
          今天: [new Date(), new Date()],
          昨天: [addDays(new Date(), -1), addDays(new Date(), -1)],
          本月: [startOfMonth(new Date()), endOfMonth(new Date())],
          本年: [startOfYear(new Date()), endOfYear(new Date())],
          上一周: [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ],
          上一月: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      },

      fields: [
        {
          key: "entCode",
          label: "企业税号",
          thStyle: "min-width:150px;"
        },
        {
          key: "entName",
          label: "企业名称",
          thStyle: "min-width:220px;"
        },

        
     
        {
          key: "createTime",
          label: "创建时间",
          thClass: "datetime"
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          entCode: "",
          keywords: "",
          daterange: {
            startDate: addDays(new Date(), -30),
            endDate: new Date()
          },
          createDate: []
        },
        sortOrder: { createTime: "descending" }
      },
     
     
      // 以下为页面状态控制参数
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数

      // 以下为表单校验规则

      // 以上为表单校验规则
    };
  },
 
  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    //this.initInfo();
  },
  mounted() {
    // 异步加载列表数据

    this.handleQuery();
    //this.list();

    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {

    handleQuery(){
      this.list()
    },
    // 异步加载列表数据
    list(page) {
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.createDate[0] = addHours(
          this.queryParam.criteria.daterange.startDate,
          8
        );
        this.queryParam.criteria.createDate[1] = addHours(
          this.queryParam.criteria.daterange.endDate,
          8
        );
      }
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      entFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },
    handleView(item){
      const { href } = this.$router.resolve({
          path: "/tcs/upload-task-list",
          query: { e: item.entCode }
        });
        
        window.open(href, "_blank");
    }
   

    
  }
};
</script>

<style >

.datetime{
  min-width: 180px;
}
.actions {
  width: 150px;
}
.blank {
  width: 80px;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
</style>
